import React from "react";

export default function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1603_77409)">
        <path
          d="M13.019 25C19.9331 25 25.5381 19.4036 25.5381 12.5C25.5381 5.59644 19.9331 0 13.019 0C6.10497 0 0.5 5.59644 0.5 12.5C0.5 19.4036 6.10497 25 13.019 25Z"
          fill="#E0E0E0"
        />
        <path
          d="M13.019 24.6201C19.828 24.6201 25.3477 19.1087 25.3477 12.31C25.3477 5.51139 19.828 0 13.019 0C6.20997 0 0.690186 5.51139 0.690186 12.31C0.690186 19.1087 6.20997 24.6201 13.019 24.6201Z"
          fill="white"
        />
        <mask
          id="mask0_1603_77409"
          maskUnits="userSpaceOnUse"
          x="4"
          y="4"
          width="18"
          height="17"
        >
          <path
            d="M21.0099 10.8662H13.2093V14.0957H17.6994C17.2808 16.1474 15.5304 17.3252 13.2093 17.3252C10.4695 17.3252 8.26255 15.1216 8.26255 12.386C8.26255 9.65044 10.4695 7.4468 13.2093 7.4468C14.3889 7.4468 15.4543 7.86474 16.2915 8.54863L18.7268 6.11701C17.2428 4.82522 15.3402 4.02734 13.2093 4.02734C8.56696 4.02734 4.83789 7.75075 4.83789 12.386C4.83789 17.0213 8.56696 20.7447 13.2093 20.7447C17.395 20.7447 21.2001 17.7052 21.2001 12.386C21.2001 11.8921 21.124 11.3602 21.0099 10.8662Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1603_77409)">
          <path
            d="M4.0769 17.3257V7.44727L10.5457 12.3865L4.0769 17.3257Z"
            fill="#FBBC05"
          />
        </g>
        <mask
          id="mask1_1603_77409"
          maskUnits="userSpaceOnUse"
          x="4"
          y="4"
          width="18"
          height="17"
        >
          <path
            d="M21.0099 10.8662H13.2093V14.0957H17.6994C17.2808 16.1474 15.5304 17.3252 13.2093 17.3252C10.4695 17.3252 8.26255 15.1216 8.26255 12.386C8.26255 9.65044 10.4695 7.4468 13.2093 7.4468C14.3889 7.4468 15.4543 7.86474 16.2915 8.54863L18.7268 6.11701C17.2428 4.82522 15.3402 4.02734 13.2093 4.02734C8.56696 4.02734 4.83789 7.75075 4.83789 12.386C4.83789 17.0213 8.56696 20.7447 13.2093 20.7447C17.395 20.7447 21.2001 17.7052 21.2001 12.386C21.2001 11.8921 21.124 11.3602 21.0099 10.8662Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1603_77409)">
          <path
            d="M4.0769 7.44691L10.5457 12.3861L13.2093 10.0685L22.3417 8.58673V3.26758H4.0769V7.44691Z"
            fill="#EA4335"
          />
        </g>
        <mask
          id="mask2_1603_77409"
          maskUnits="userSpaceOnUse"
          x="4"
          y="4"
          width="18"
          height="17"
        >
          <path
            d="M21.0099 10.8662H13.2093V14.0957H17.6994C17.2808 16.1474 15.5304 17.3252 13.2093 17.3252C10.4695 17.3252 8.26255 15.1216 8.26255 12.386C8.26255 9.65044 10.4695 7.4468 13.2093 7.4468C14.3889 7.4468 15.4543 7.86474 16.2915 8.54863L18.7268 6.11701C17.2428 4.82522 15.3402 4.02734 13.2093 4.02734C8.56696 4.02734 4.83789 7.75075 4.83789 12.386C4.83789 17.0213 8.56696 20.7447 13.2093 20.7447C17.395 20.7447 21.2001 17.7052 21.2001 12.386C21.2001 11.8921 21.124 11.3602 21.0099 10.8662Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_1603_77409)">
          <path
            d="M4.0769 17.3253L15.4924 8.58673L18.4985 8.96667L22.3417 3.26758V21.5047H4.0769V17.3253Z"
            fill="#34A853"
          />
        </g>
        <mask
          id="mask3_1603_77409"
          maskUnits="userSpaceOnUse"
          x="4"
          y="4"
          width="18"
          height="17"
        >
          <path
            d="M21.0099 10.8662H13.2093V14.0957H17.6994C17.2808 16.1474 15.5304 17.3252 13.2093 17.3252C10.4695 17.3252 8.26255 15.1216 8.26255 12.386C8.26255 9.65044 10.4695 7.4468 13.2093 7.4468C14.3889 7.4468 15.4543 7.86474 16.2915 8.54863L18.7268 6.11701C17.2428 4.82522 15.3402 4.02734 13.2093 4.02734C8.56696 4.02734 4.83789 7.75075 4.83789 12.386C4.83789 17.0213 8.56696 20.7447 13.2093 20.7447C17.395 20.7447 21.2001 17.7052 21.2001 12.386C21.2001 11.8921 21.124 11.3602 21.0099 10.8662Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_1603_77409)">
          <path
            d="M22.3418 21.505L10.5458 12.3865L9.02368 11.2467L22.3418 7.44727V21.505Z"
            fill="#4285F4"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1603_77409">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
